import Vue from '@/index.js'

import page from '@/mixins/page'

import layoutProductData from '@/components/layout/product/layout-product-data'
import layoutProductDetails from '@/components/layout/product/layout-product-details'
import sectionProductsCarousel from '@/components/sections/section-products-carousel'
import layoutTestimonialCard from '@/components/layout/layout-testimonial-card'
import sectionTestimonials from '@/components/sections/section-testimonials'
import sectionPropsdetail from '@/components/sections/section-propsdetail'
import sectionSize from '@/components/sections/section-size'
import layoutProductFavoriteButton from '@/components/layout/layout-favorite-button'
import sectionViewed from '@/components/sections/section-viewed'
import layoutProductViewer360 from '@/components/layout/product/layout-product-viewer360'
import layoutProductYoutube from '@/components/layout/product/layout-product-youtube'


export default new Vue({
  el: '#app',
  components: {
    layoutProductData,
    layoutProductDetails,
    sectionProductsCarousel,
    sectionTestimonials,
    sectionPropsdetail,
    layoutTestimonialCard,
    sectionSize,
    layoutProductFavoriteButton,
    sectionViewed,
    layoutProductViewer360,
    layoutProductYoutube
  },
  mixins: [page]
})
